export default __webpack_public_path__ + "static/media/download.1a35218e.svg";